import Header from "../common/Header";
import MapAndCards from "../../components/common/MapAndCards";

export default function Contact() {
  return (
    <div className="bg-slate-100 min-h-screen">
      {/* Header */}
      <Header />
      <MapAndCards />
    </div>
  );
}